import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const STATUS_META = {
  open: { label: "Open", color: "#2563EB", bg: "bg-blue-50", text: "text-blue-700", dot: "bg-blue-600" },
  in_progress: { label: "In Progress", color: "#EA580C", bg: "bg-orange-50", text: "text-orange-700", dot: "bg-orange-500" },
  closed: { label: "Closed", color: "#16A34A", bg: "bg-green-50", text: "text-green-700", dot: "bg-green-600" },
};

export const PRIORITY_META = {
  low: { label: "Low", color: "#3B82F6", bg: "bg-blue-100", text: "text-blue-700" },
  medium: { label: "Medium", color: "#F59E0B", bg: "bg-amber-100", text: "text-amber-800" },
  high: { label: "High", color: "#DC2626", bg: "bg-red-100", text: "text-red-700" },
};
